import React from "react";
import style from "css/room.module.css";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const dateTimeFormat = "HH:mm";

function AllSegs({ open, onClose, list, onEdit }) {
  return (
    <Drawer
      classNames={{
        body: style.reserve,
      }}
      open={open}
      height="100%"
      closable={false}
      placement="bottom"
      onClose={onClose}
    >
      <section className={style.reserve_header}>
        <p className={style.reserve_header_title}>일정 목록</p>
        <CloseOutlined
          className={style.reserve_header_close}
          onClick={onClose}
        />
      </section>

      <section className={style.reserve_body}>
        {open &&
          list.length > 0 &&
          list.map((item, idx) => (
            <Item
              key={idx}
              data={item}
              onEdit={(res) => {
                onClose();
                onEdit(res);
              }}
            />
          ))}
      </section>
    </Drawer>
  );
}

export default AllSegs;

function Item({ data, onEdit }) {
  const item = data.event._def.extendedProps.data;

  const setDateTimeFormat = (date) => {
    return dayjs(new Date(date)).format(dateTimeFormat);
  };
  return (
    <div className={style.reserve_item} onClick={() => onEdit(item)}>
      <p className={style.reserve_item_title}>{item.TITLE}</p>
      <article className={style.reserve_item_article}>
        <p>{item.HOST_NM}</p>
        <div className={style.reserve_item_time}>
          <p>{setDateTimeFormat(data.start)}</p>
          <p>-</p>
          <p>{setDateTimeFormat(data.end)}</p>
        </div>
      </article>
    </div>
  );
}
